import React from "react";
import styled from "styled-components";
import { InnerLayout } from "../styles/Layouts";
import Title from "./Title";
import ReviewItem from "./ReviewItem";

function ReviewsSetion() {
  return (
    <ReviewsStyled>
      <Title title={"LinkedIn"} span={"Testimonials"} />
      <InnerLayout>
        <div className="reviews">
          <ReviewItem
            text={
              "I worked with Preeti on TechMahindra(Formerly Mahindra Satyam), She is good at grasping things, and have intense knowledge of Java and other technology platforms. She is very responsible and has a hard-working attitude. She would definitely be a Strong resource to work with. I would Highly recommend her."
            }
            author={
              "- Ankush Khandelwal (Senior Software Engineer at BluJay Solutions)"
            }
          />
          <ReviewItem
            text={
              "I worked with Preeti for nearly 2 years as part of the QA team working on the same project. She comes across as a strong-headed, multi-tasking specialist, straight-talking person. She is a test automation expert. She is lightning fast in her work and very very focused and detail-oriented. She is a finisher, no matter whatever tasks are assigned, expect it to complete without any delay. It is a pleasure knowing her and working with her and I rightly recommend her for the capable and exceptional talent she has. All the very best Preeti."
            }
            author={"- Sushant Hublikar (Business Analyst at Resolution Life)"}
          />
          <ReviewItem
            text={
              "On the Automation project, I have found Preeti to be a hard working individual who helped us achieve our objective of automating our test suite using Sahi initially on her own and later with 2 more test engineers by giving KT to the team and handling the queries and questions aptly. She never compromised on the deliverable quality be it reporting bugs or the Automation scripts. Her technical and communication skills have helped us in the launching/maintenance of modules successfully. She is definitely an asset to any team and organization she works with and I wish her all the best."
            }
            author={"-  Basheer Shaik (Test Lead at Version 1)"}
          />
          <ReviewItem
            text={
              "One of the biggest traits of an engineer to always be alert and process the incoming requests as soon as possible with utmost quality. Preeti is a seasoned quality assurance engineer who will do proper homework in the domain she is working on and understand the project in 360 degree view and she will be ready to test any feature on any module of the project .. She never said that it is not her module or she is tied up with something .. She is always ready to take up challenges and she has the confidence to tackle that challenge and she will always be ready to walk an extra mile to accomplish tasks on time .. It was great working with you Preeti ..She is well versed in Test planning, Test case writing, Test case execution, defect tracking, SDLC, Regression testing, Black box testing, White box testing, Sanity testing, Alpha testing, Automation of test cases."
            }
            author={" - GAUTHAM SIDDARTH #ProdMan (Product Manager @ Visa)"}
          />
        </div>
      </InnerLayout>
    </ReviewsStyled>
  );
}

const ReviewsStyled = styled.section`
  .reviews {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1.5rem;
    width: 100%;
    @media screen and (max-width: 650px) {
      grid-template-columns: repeat(1, 1fr);
    }
  }
`;

export default ReviewsSetion;
